import Vue from "vue";
import VueApollo from "vue-apollo";
import { createApolloClient } from "vue-cli-plugin-apollo/graphql-client";

Vue.use(VueApollo);

const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP;

const options = {
    httpEndpoint,
    persisting: false,
    websocketsOnly: false,
    ssr: false,
    fetchPolicy: "no-cache",

    getAuth: () => {return localStorage.getItem("token")}
}


export function createProvider () {
    const { apolloClient } = createApolloClient({
        ...options,
    });

    const apolloProvider = new VueApollo({
        defaultClient: apolloClient,
        defaultOptions: {
            $query: {
              fetchPolicy: "no-cache",
              errorPolicy: "all",
            },
        },
        errorHandler (error) {
            // eslint-disable-next-line no-console
            console.log("%cError", error.message)
        },
    })

    return apolloProvider;
}
